import { createEffect } from "effector";
import { getInvoicesByFleet, payInvoice } from "../../services/invoiceService";
import { Invoice } from "../../types/invoices.types";
import { AppError } from "../../services/classes";

export const getInvoicesByFleetEffect = createEffect<string, Invoice[], AppError>(
  async (fleetId: string) => {
    return await getInvoicesByFleet(fleetId);
  }
);

export const payInvoiceEffect = createEffect<string, Invoice, AppError>(
  async (invoiceId: string) => {
    return await payInvoice(invoiceId);
  }
);
